export default "__VITE_ASSET__BDclq2lv__"